import { useState, useEffect } from "react";
import {
  useCourseOptions,
  useModuleByIdOptions,
  useTopicByIdOptions,
} from "../../hooks/dropdownOptions";

export const useFileFormConfig = (courseFile,mode) => {
  const [selectedCourseId, setSelectedCourseId] = useState(courseFile?.Topic?.topicModule?.course_id || null);
  const [selectedModuleId, setSelectedModuleId] = useState(courseFile?.Topic?.module_id || null);

  const courseOptions = useCourseOptions();
  const moduleOptions = useModuleByIdOptions(selectedCourseId);
  const topicOptions = useTopicByIdOptions(selectedModuleId);

  useEffect(() => {
    if (courseFile?.Topic?.topicModule?.course_id) {
      setSelectedCourseId(courseFile?.Topic?.topicModule?.course_id);
    }
    if (courseFile?.Topic?.module_id) {
      setSelectedModuleId(courseFile?.Topic?.module_id);
    }
  }, [courseFile?.Topic?.topicModule?.course_id, courseFile?.Topic?.module_id]);
  const titleFieldType = mode === "update" ? "text" : "inputtranslation";

  const commonFields = [
    {
      key: "name",
      label: "Content Title",
      type: titleFieldType,
      placeholder: "Enter Content title",
      required: true,
      alphaOnly: true,
    },
    {
      key: "description",
      label: "Content Description",
      type: titleFieldType,
      placeholder: "Enter Content description",
      required: true,
      alphaOnly: true,
    },
    {
      key: "courseId",
      label: "Course",
      type: "dropdown",
      options: courseOptions,
      placeholder: "Select a course",
      required: true,
      onChange: (e) => setSelectedCourseId(e.value),
    },
    {
      key: "moduleId",
      label: "Module",
      type: "dropdown",
      options: moduleOptions,
      placeholder: "Select a Module",
      required: true,
      onChange: (e) => setSelectedModuleId(e.value),
    },
    {
      key: "topicId",
      label: "Topic",
      type: "dropdown",
      options: topicOptions,
      placeholder: "Select a Topic",
      required: true,
    },
  ];
  const contentFields = [
    {
      key: "laungaugeId",
      label: "Language",
      type: "dropdown",
      options: [
        { label: "Marathi", value: 2 },
        { label: "English", value: 1 },
      ],
      placeholder: "Select a Language",
      required: true,
    },
    {
      key: "contentType",
      label: "Content Type",
      type: "dropdown",
      options: [
        { label: "Custom", value: "Custom" },
        { label: "Youtube", value: "Youtube" },
      ],
      placeholder: "Select a Content Type",
      required: true,
    },
    {
      key: "path",
      label: "Content URL",
      type: "text",
      placeholder: "Add Content URL",
      required: true,
    },
    {
      key: "video",
      label: "Content File",
      type: "file",
      placeholder: "Upload File",
      required: true,
    },
    {
      key: "thumbnailPath",
      label: "Content Thumbnail",
      type: "file",
      placeholder: "Upload Thumbnail",
      required: true,
    },
    {
      key: "tags",
      label: "Tags",
      type: "chips",
      placeholder: "Enter tag",
      required: true,
    },
  ];
  return {
    formTitle: "Content",
    initialCommonData: {
      name: null,
      description: null,
      courseId: null,
      moduleId: null,
      topicId: null,
    },
    initialContentData: {
      laungaugeId: null,
      contentType: "",
      path: "",
      video: "",
      thumbnailPath: "",
      tags: [],
    },
    commonFields,
    contentFields,
  };
};